module.exports = __webpack_public_path__ + "img/zyjy.b50c12ab.png";